export const FETCH_CONTACTS_PENDING = 'FETCH_CONTACTS_PENDING';
export const FETCH_CONTACTS_FULFILLED = 'FETCH_CONTACTS_FULFILLED';
export const FETCH_CONTACTS_REJECTED = 'FETCH_CONTACTS_REJECTED';
export const SET_CONTACT = 'SET_CONTACT';

export const LOGIN = 'LOGIN';
export const LOGIN_PENDING = 'LOGIN_PENDING';
export const LOGIN_FULFILLED = 'LOGIN_FULFILLED';
export const LOGIN_REJECTED = 'LOGIN_REJECTED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_PENDING = 'LOGOUT_PENDING';
export const LOGOUT_FULFILLED = 'LOGOUT_FULFILLED';
export const LOGOUT_REJECTED = 'LOGOUT_REJECTED';

export const SIGNUP = 'SIGNUP';
export const SIGNUP_PENDING = 'SIGNUP_PENDING';
export const SIGNUP_FULFILLED = 'SIGNUP_FULFILLED';
export const SIGNUP_REJECTED = 'SIGNUP_REJECTED';

export const SIGNED_IN = 'SIGNED_IN';
export const SIGNED_IN_PENDING = 'SIGNED_IN_PENDING';
export const SIGNED_IN_FULFILLED = 'SIGNED_IN_FULFILLED';
export const SIGNED_IN_REJECTED = 'SIGNED_IN_REJECTED';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_PENDING = 'UPDATE_USER_PENDING';
export const UPDATE_USER_FULFILLED = 'UPDATE_USER_FULFILLED';
export const UPDATE_USER_REJECTED = 'UPDATE_USER_REJECTED';

export const SET_USER_ID = 'SET_USER_ID';
export const FETCH_CONTACTS = 'FETCH_CONTACTS';
export const FETCH_ONE_CONTACT = 'FETCH_ONE_CONTACT';
export const FETCH_ONE_CONTACT_PENDING = 'FETCH_ONE_CONTACT_PENDING';
export const FETCH_ONE_CONTACT_REJECTED = 'FETCH_ONE_CONTACT_REJECTED';
export const SET_CONTACT_DETAILS = 'SET_CONTACT_DETAILS';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const DELETE_CONTACT_FULFILLED = 'DELETE_CONTACT_FULFILLED';
export const SET_FIRST_NAME = 'SET_FIRST_NAME';
export const SET_LAST_NAME = 'SET_LAST_NAME';
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
export const SET_ADDRESS = 'SET_ADDRESS';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_IMAGE = 'SET_IMAGE';
export const SET_COMM_FREQUENCY = 'SET_COMM_FREQUENCY';
export const SET_LAST_CONTACTED_DATE = 'SET_LAST_CONTACTED_DATE';
export const SET_BIRTHDATE = 'SET_BIRTHDATE';
export const SET_SPECIAL_DATES = 'SET_SPECIAL_DATES';
export const SET_NOTES = 'SET_NOTES';
export const SET_YELLOW_ZONE = 'SET_YELLOW_ZONE';
export const SET_RED_ZONE = 'SET_RED_ZONE';
export const SET_CONNECTION_HISTORY = 'SET_CONNECTION_HISTORY';
export const SET_DEADLINE_OBJECT = 'SET_DEADLINE_OBJECT';
export const SET_DEADLINE_DATE = 'SET_DEADLINE_DATE';
export const SET_NOTIFICATION_RANGE = 'SET_NOTIFICATION_RANGE';
export const SET_CONTACT_CREATED_ON = 'SET_CONTACT_CREATED_ON';
export const SET_TOTAL_GREEN_ZONE_DAYS = 'SET_TOTAL_GREEN_ZONE_DAYS';
export const SET_TOTAL_YELLOW_ZONE_DAYS = 'SET_TOTAL_YELLOW_ZONE_DAYS';
export const SET_TOTAL_RED_ZONE_DAYS = 'SET_TOTAL_RED_ZONE_DAYS';
export const SET_CURRENT_ZONE_RATIO = 'SET_CURRENT_ZONE_RATIO';
export const SET_DEADLINE_UNIT = 'SET_DEADLINE_UNIT';
export const SET_DEADLINE_NUMBER = 'SET_DEADLINE_NUMBER';
export const SET_SLIDER_1 = 'SET_SLIDER_1';
export const SET_SLIDER_2 = 'SET_SLIDER_2';
export const CLEAR_CONTACT_DETAILS = 'CLEAR_CONTACT_DETAILS';
